var map = {
	"./acmeicon.png": "./src/common/images/Logo/Favicon/acmeicon.png",
	"./albertsonsicon.png": "./src/common/images/Logo/Favicon/albertsonsicon.png",
	"./amigosicon.png": "./src/common/images/Logo/Favicon/amigosicon.png",
	"./haggenicon.png": "./src/common/images/Logo/Favicon/haggenicon.png",
	"./jeweloscoicon.png": "./src/common/images/Logo/Favicon/jeweloscoicon.png",
	"./luckyicon.png": "./src/common/images/Logo/Favicon/luckyicon.png",
	"./marketstreeticon.png": "./src/common/images/Logo/Favicon/marketstreeticon.png",
	"./pavilionsicon.png": "./src/common/images/Logo/Favicon/pavilionsicon.png",
	"./randallsicon.png": "./src/common/images/Logo/Favicon/randallsicon.png",
	"./safewaysicon.png": "./src/common/images/Logo/Favicon/safewaysicon.png",
	"./shawsicon.png": "./src/common/images/Logo/Favicon/shawsicon.png",
	"./starmarketicon.png": "./src/common/images/Logo/Favicon/starmarketicon.png",
	"./tomthumbicon.png": "./src/common/images/Logo/Favicon/tomthumbicon.png",
	"./unitedsupermarketsicon.png": "./src/common/images/Logo/Favicon/unitedsupermarketsicon.png",
	"./vonsicon.png": "./src/common/images/Logo/Favicon/vonsicon.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/common/images/Logo/Favicon sync recursive ^\\.\\/.*$";